import { numberToStr, strToNumber } from '@/library/utils/numbers';
export { numberToStr, strToNumber };

export const formatNumber = val => {
  if (!val) return null;

  var parts = val.toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  return parts.join('.');
};

export const trimFloatNumber = num => {
  return strToNumber(parseFloat(num).toFixed(2));
};

export const padLeadingZeros = (num, size) => {
  if (num == 0 && num !== '') return '0';

  let numString = num + '';

  if (numString.length) {
    while (numString.length < size) numString = '0' + numString;
    return numString;
  } else {
    return '';
  }
};

export const roundNumber = num => {
  return numberToStr(num, 2, 2);
};

export const hasValue = value => value || value === 0;

export const scaleNumberIsAllowed = (value, { min, max, step }) =>
  value >= min && value <= max && value % step === 0;

export const calculatePercentage = (value, total) => {
  if (!total) return 0;

  return (value / total) * 100;
};
